import type { CipherText } from "@b2bportal/purchase-api";
import type {
  AirPriceDropContext,
  FlightContext,
  ParentState,
} from "@hopper-b2b/checkout";

export enum PassportState {
  idle = "idle",
  update = "update",
  updateAndContinue = "updateAndContinue",
  validate = "validate",
}

export interface PaymentStateContext {
  paymentSessionToken?: string;
  paymentQuoteToken?: CipherText;
  error?: PaymentError;
  visited: boolean;
}

export interface FlightMachineContext
  extends Required<Omit<FlightContext, ParentState.cardPayment>> {
  [ParentState.payment]: PaymentStateContext;
  [ParentState.bookingConfirmation]: unknown;
  [ParentState.priceDrop]: AirPriceDropContext;
}

export enum PaymentErrorModalTypes {
  ListPaymentMethods = "ListPaymentMethods",
  VerifyPayment = "VerifyPayment",
  CardDeclined = "CardDeclined",
  ExcessiveUserActivity = "ExcessiveUserActivity",
  GenericError = "GenericError",
  DeletePayment = "DeletePayment",
}

export enum PassportErrorModalTypes {
  TripPricing = "TripPricing",
  UpdatePassenger = "UpdatePassenger",
  ValidatePassengers = "ValidatePassengers",
}

export interface PaymentError {
  type: PaymentErrorModalTypes;
  data: unknown;
}

export interface PassportError {
  type: PassportErrorModalTypes;
  data: unknown;
}

export enum CheckoutQueryParams {
  tripCategory = "tripCategory",
  departureLabel = "departureLabel",
  returnLabel = "returnLabel",
  tripId = "tripId",
  outgoingSliceId = "outgoingSliceId",
  outgoingFareId = "outgoingFareId",
  outgoingFareRating = "outgoingFareRating",
  returnSliceId = "returnSliceId",
  returnFareId = "returnFareId",
  returnFareRating = "returnFareRating",
  contactCountry = "contactCountry",
  contactPhone = "contactPhone",
  contactEmail = "contactEmail",
  selectedLapInfantIds = "selectedLapInfantIds",
  selectedPassengerIds = "selectedPassengerIds",
  selectedPaymentMethodId = "selectedPaymentMethodId",
  checkoutState = "checkoutState",
  priceFreezeId = "priceFreezeId",
}
